// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const COMBINATION_TYPE_VALUES = [
  'OR',
  'AND',
  'NOR',
  'NAND'
] as const;

/** @see net/disy/cadenza/query/datasource/api/condition/CombinationType.java */
export type CombinationType = typeof COMBINATION_TYPE_VALUES[number];

export const CombinationType = {
  values: COMBINATION_TYPE_VALUES as readonly CombinationType[]
} as const;

// </GENERATED-CODE>
